// 3_pages/product_related_files.js
// On product pages, moves the #relatedFiles list into the analysis section, strips
// file-size annotations (e.g. "(123 kB)") from the links, and removes the show-tests
// button.

export function init() {
	if (!document.body.classList.contains("type-product")) return;

	moveRelatedFilesToAnalysis();
}

function moveRelatedFilesToAnalysis() {
	const relatedFiles = document.querySelector("#relatedFiles");
	if (!relatedFiles) return;

	const natiosAnalysis = document.querySelector(".product-widgets .natios-analysis .natios-analysis-content-left");
	if (natiosAnalysis) {
		const allHrefsInRelatedFiles = relatedFiles.querySelectorAll("a:not(.btn)");
		if (allHrefsInRelatedFiles && allHrefsInRelatedFiles.length > 0) {
			allHrefsInRelatedFiles.forEach((a) => {
				// Remove any text in parentheses with "kB" or "MB" etc.
				a.textContent = a.textContent.replace(/\(\s*[\d.,]+\s*[kMGT]?B\s*\)/gi, "").trim();
			});
		}
		natiosAnalysis.appendChild(relatedFiles);
		const showTestsButton = natiosAnalysis.querySelector(".show-tests-button");
		if (showTestsButton) {
			showTestsButton.remove();
		}
	}
	/* Nothing yet */
	/* else {
		const basicDescription = document.querySelector("#description .basic-description");
		if (basicDescription) {
			basicDescription.insertAdjacentElement("afterend", relatedFiles);
		}
	} */
}
